export default {
  conversations: (state) => state.conversations,
  groupedConversations: (state) => {
    const groupsByKey = state.conversations.reduce((groups, conversation) => {
      const dateValue = conversation.updatedAt || conversation.createdAt;
      const date = dateValue ? new Date(dateValue) : null;
      const hasValidDate = date && !Number.isNaN(date.getTime());
      const key = hasValidDate
        ? `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}`
        : 'unknown';
      const label = hasValidDate
        ? date.toLocaleString(undefined, { month: 'long', year: 'numeric' })
        : 'Unknown date';

      if (!groups[key]) {
        groups[key] = {
          key,
          label,
          sortDate: hasValidDate ? date.getTime() : 0,
          conversations: [],
        };
      }

      groups[key].conversations.push(conversation);
      return groups;
    }, {});

    return Object.values(groupsByKey)
      .sort((a, b) => b.sortDate - a.sortDate)
      .map((group) => ({
        ...group,
        conversations: group.conversations.slice().sort((a, b) => {
          const aDate = new Date(a.updatedAt || a.createdAt || 0).getTime();
          const bDate = new Date(b.updatedAt || b.createdAt || 0).getTime();
          return bDate - aDate;
        }),
      }));
  },
  activeConversationId: (state) => state.activeConversationId,
  activeMessages: (state) => (state.activeConversationId
    ? state.messagesByConversationId[state.activeConversationId] || []
    : []),
  isLoadingConversations: (state) => state.isLoadingConversations,
  isLoadingActiveConversation: (state) => state.isLoadingActiveConversation,
  isStreaming: (state) => state.isStreaming,
  error: (state) => state.error,
};
